import { capitalize, formatDateStringForDisplay, fetchColor } from '@/utils/helpers'

export const normalizeVulnData = (cve) => {
  if (!cve) {
    return cve
  }

  const {
    id,
    cve_identifier: identifier, // IntelAPI Trending Widget
    cve_id: cveId, // Extended-API
    executive_summary: executiveSummary,
    description,
    exploitation_state: exploit,
    risk_rating: risk,
    was_zero_day: zeroDay,
    observed_in_the_wild: inTheWild,
    is_predicted: isPredicted,
    aliases,
    mve_id: mveId,
    associated_reports: associatedReports
  } = cve

  const exploitRating = (exploit || 'No Known')

  const riskRating = Array.isArray(risk) ? capitalize(risk[0]) : (capitalize(risk) || '')

  const yesOrNo = value => {
    if (value === 'redacted') return value
    return value ? 'Yes' : 'No'
  }

  const lastUpdated = cve.publish_date || cve.updated_date
  const firstPublished = cve.date_of_disclosure || cve.first_publish_date

  return {
    id,
    name: cveId || identifier,
    summary: executiveSummary || description,
    exploitRating,
    riskRating,
    zeroDay: yesOrNo(zeroDay),
    inTheWild: yesOrNo(inTheWild),
    lastUpdated: formatDateStringForDisplay(lastUpdated),
    firstPublished: formatDateStringForDisplay(firstPublished),
    exploitColor: fetchColor(exploitRating),
    riskColor: fetchColor(riskRating),
    zeroDayColor: fetchColor(yesOrNo(zeroDay)),
    inTheWildColor: fetchColor(yesOrNo(inTheWild)),
    isPredicted,
    aliases,
    mveId,
    associatedReports
  }
}
